import { ExternalLiquidityStats } from './types'

export const fetchData = (venues: number[], security: string) =>
  ({
    type: `externalLiquidityStats.fetchData`,
    payload: { venues, security }
  } as const)
export type FetchAction = ReturnType<typeof fetchData>

export const addData = (stats: ExternalLiquidityStats[]) =>
  ({
    type: `externalLiquidityStats.addData`,
    payload: stats
  } as const)
export type AddAction = ReturnType<typeof addData>

export const clearData = () =>
  ({
    type: `externalLiquidityStats.clearData`
  } as const)
export type ClearAction = ReturnType<typeof clearData>

export const fetchFail = (error: string) =>
  ({
    type: `externalLiquidityStats.fetchFail`,
    payload: error,
    error: true
  } as const)
export type FailAction = ReturnType<typeof fetchFail>

export type ExternalLiquidityStatsAction =
  | FetchAction
  | AddAction
  | ClearAction
  | FailAction
